import { render, staticRenderFns } from "./ListChatContent.vue?vue&type=template&id=f38a4f34&scoped=true"
import script from "./ListChatContent.vue?vue&type=script&lang=js"
export * from "./ListChatContent.vue?vue&type=script&lang=js"
import style0 from "./ListChatContent.vue?vue&type=style&index=0&id=f38a4f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38a4f34",
  null
  
)

export default component.exports